"use client";

import { Box } from "@ecco/ui/box";
import React, { useState } from "react";
import { styles } from "./EccoPaymentLoading.styles";
import { NextImage } from "@ecco/ui/next-image";

export const EccoPaymentLoading = () => {
    const [imageError, setImageError] = useState(false);

    const handleImageError = () => {
        setImageError(true);
    };

    return (
        <Box sx={styles.loading}>
            {!imageError ? (
                <NextImage
                    src="/assets/ecco-payment-loader/ecco-spinner.gif"
                    alt="Loading..."
                    width={36}
                    height={36}
                    onError={handleImageError}
                />
            ) : (
                <div className="css-spinner" />
            )}
        </Box>
    );
};
